import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import CategoryDetails from '../../components/Pages/Category';

const { displayName } = config;

export default function Category(): React.ReactNode | null {
  document.title = `${displayName}: Category details`;

  return (
    <Layout>
      <CategoryDetails />
    </Layout>
  );
}
